import { useLocation, useNavigate } from 'react-router-dom';
import { Menu, Spin, type MenuProps } from 'antd';
import navigationConfig from 'configs/NavigationConfig';
import useUser from 'utils/useUser';
import { useTheme } from 'context/ThemeProvider/ThemeProvider';
import Utils from 'utils/Utils';

type MenuItem = Required<MenuProps>['items'][number];

const SideNavContent = ({ backgroundColor }: { backgroundColor?: string }) => {
  const { theme, setOpenMobileNav } = useTheme();
  const location = useLocation();
  const routeInfo = Utils.getRouteInfo(navigationConfig, location.pathname);
  const navigate = useNavigate();
  const meRequest = useUser();
  const roleName = meRequest.data?.role.roleName;
  const items: MenuItem[] = meRequest.isLoading
    ? [
        {
          type: 'group',
          label: (
            <div style={{ margin: 24 }}>
              <Spin />
            </div>
          ),
        },
      ]
    : navigationConfig
        .filter((menu) => roleName && menu.roles.includes(roleName))
        .map((menu) => ({
          key: menu.key,
          label: menu.title,
          type: 'group',
          children: menu.submenu
            ?.filter((menu) => roleName && menu.roles.includes(roleName))
            .map(({ key, title, icon: Icon, path }) => ({
              key: key,
              label: title,
              onClick: () => {
                if (path) {
                  navigate(path);
                }
                setOpenMobileNav(false);
              },
              icon: Icon ? <Icon /> : undefined,
            })),
        }));
  return (
    <Menu
      mode="inline"
      theme={theme}
      style={{ borderInlineEnd: 'none', backgroundColor }}
      defaultSelectedKeys={[routeInfo?.key || '']}
      items={items}
    />
  );
};

export default SideNavContent;
